import React from 'react'
import styled from './electronics.module.css'

function Bottom() {
  return (
    <div className={styled.bottom}>
        <img  src='https://res.cloudinary.com/crunchbase-production/image/upload/c_lpad,f_auto,q_auto:eco,dpr_1/r3wjitb1zgdpuysvqhjx' alt='logo_of_site' />
        <p>About Us</p>
        <p>Refer A Friend</p>
        <p>Career</p>
        <p>Support</p>
        <p>Blog</p>
        <p>Furniture Packages</p>
        <p>Privacy</p>
        <p>T&C</p>
    </div>
  )
}

export default Bottom
